module.exports = __webpack_public_path__ + "img/premium-set.fd16100f.png";